import React from "react";
import { useState } from "react";
import { useRouter } from "next/router";
import { Hooks } from "@xt/xtbase";
const {useIntl,FormattedMessage} = Hooks;

import axios from "utils/axios";
import FormItem from "components/App/FormItem";
import sessionStorage from "utils/sessionStorage";
import ButtonBig from "components/Antd/Button/big";
import FormItemPassword from "components/App/FormItem/Password";

import { doRsaEncrypt, getAbsoluteUrl } from "utils/method";
import { post_passwdPublicKey } from "api/uaapi/uaa";
import { put_nResetPasswd } from "api/uaapi/user";
import { put_publicKey, put_faLoginPwd } from "api/uaapi/account";
import { message } from "antd";

export default function StepThree() {
  const intl = useIntl();
  const router = useRouter();

  React.useEffect(() => {
    const faResultId = sessionStorage.get("faResultId");
    // const faId = sessionStorage.get("faId");
    if (!faResultId) {
      const query = { ...router.query };
      delete query.step;
      if (typeof location !== "undefined") {
        location.replace(
          getAbsoluteUrl({
            pathname: "/login",
            locale: router.locale,
            query,
          })
        );
      } else {
        router.replace({
          pathname: "/login",
          query,
        });
      }
    }

    return () => {
      sessionStorage.remove("faResultId");
      // sessionStorage.remove("faId");
    };
  }, []);

  const [loading, setLoading] = useState(false);
  const [newPwd, setNewPwd] = useState("");
  const [confirmPwd, setConfirmPwd] = useState("");
  const [isShowErr, setIsShowErr] = useState(false);
  const faResultId = sessionStorage.keyList["faResultId"]
    ? sessionStorage.get("faResultId")
    : "";

  const [newPwdStat, setNewPwdStat] = useState({
    isOK: true,
    errMsg: "",
  });

  const [confirmPwdStat, setConfirmPwdStat] = useState({
    isOK: true,
    errMsg: "",
  });

  const handleUpdateNewPwd = (pwdStatus) => {
    setNewPwdStat(pwdStatus);
    setIsShowErr(false);
    if (!confirmPwd) return;
    setConfirmPwdStat({
      isOK: confirmPwd === newPwd,
      errMsg:
        confirmPwd !== newPwd
          ? intl.formatMessage({ id: "resetPwd.pwdConfirmTip" })
          : "",
    });
  };

  const handleInputBlur = () => {
    setIsShowErr(true);
  };

  const handleConfirmPwdInput = (val) => {
    setConfirmPwd(val);
    if (!val) {
      setConfirmPwdStat({
        isOK: true,
        errMsg: "",
      });
      return;
    }
    setConfirmPwdStat({
      isOK: newPwd === val,
      errMsg: "",
    });
  };

  const handleConfirm = async () => {
    if (!newPwd) {
      setNewPwdStat({
        isOK: false,
        errMsg: intl.formatMessage({ id: "resetPwd.newPwdTip" }),
      });
      return;
    }
    if (!newPwdStat.isOK) return;

    if (!confirmPwd) {
      setConfirmPwdStat({
        isOK: false,
        errMsg: intl.formatMessage({ id: "resetPwd.pwdConfirmSecTip" }),
      });
      return;
    }
    setConfirmPwdStat({
      isOK: confirmPwd === newPwd,
      errMsg:
        confirmPwd !== newPwd
          ? intl.formatMessage({ id: "resetPwd.pwdConfirmTip" })
          : "",
    });

    if (!confirmPwdStat.isOK) return;

    setLoading(true);
    const passwdPublicRes = await axios.asyncAwait(post_passwdPublicKey, {
      errorPop: true,
    });
    if (passwdPublicRes.err) return setLoading(false);
    const { publicKey, passwdId } = passwdPublicRes.data;

    /*
    const faLoginPwd = await axios.asyncAwait(put_faLoginPwd, {
      data: {
        faId: faId,
        newPassword: doRsaEncrypt(publicKey, newPwd),
      },
      errorPop: true,
      successPop: true,
    });
    setLoading(false);
    if (faLoginPwd.err) return;

    const query = { ...router.query };
    delete query.step;
    if (typeof location !== "undefined")
      location.href = getAbsoluteUrl({
        pathname: "/login",
        locale: router.locale,
        query,
      });
    else
      router.push({
        pathname: "/login",
        query,
      });
    sessionStorage.remove("faId");
     */

    put_nResetPasswd({
      data: {
        faResultId: faResultId,
        newLoginPwd: doRsaEncrypt(publicKey, newPwd),
        passwdId: passwdId,
        regChannel: "xt",
      },
      isReturnResponse: true,
    })
      .then((res) => {
        const { code, msg = "" } = res.data;
        if (code != 200) {
          message.error(msg);
          return;
        }
        message.success(msg);
        const query = { ...router.query };
        delete query.step;
        if (typeof location !== "undefined")
          location.href = getAbsoluteUrl({
            pathname: "/login",
            locale: router.locale,
            query,
          });
        else
          router.push({
            pathname: "/login",
            query,
          });
        sessionStorage.remove("faResultId");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className={"stepForm"}>
      <FormItem
        title={<FormattedMessage id="resetPwd.newPwd" />}
        errMsg={isShowErr ? newPwdStat.errMsg : ""}
      >
        <FormItemPassword
          autoFocus={true}
          value={newPwd}
          onInput={(val) => setNewPwd(val)}
          updateStatus={handleUpdateNewPwd}
          onBlur={handleInputBlur}
          isErr={isShowErr && !!newPwdStat.errMsg}
          // placeholder={intl.formatMessage({ id: "resetPwd.pwd" })}
        />
      </FormItem>

      <FormItem
        title={<FormattedMessage id="resetPwd.pwdConfirm" />}
        errMsg={confirmPwdStat.errMsg}
      >
        <FormItemPassword
          value={confirmPwd}
          popover={false}
          onInput={handleConfirmPwdInput}
          isErr={!confirmPwdStat.isOK}
          // placeholder={intl.formatMessage({ id: "resetPwd.pwd" })}
        />
      </FormItem>

      <ButtonBig
        tabIndex={3}
        className={"bigBtn"}
        onClick={handleConfirm}
        loading={loading}
      >
        <FormattedMessage id="app.confirm" />
      </ButtonBig>
    </div>
  );
}
